export default __webpack_public_path__ + "static/media/heart-x-globe-pink.272c9845.svg";